import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Observable } from 'rxjs';
import { IPage } from '@core/interfaces/ipage';

@Injectable({
  providedIn: 'root'
})
export class PageService {
  constructor(public data: DataService) { }

  getPageById(id: number): Observable<any> {
    return this.data.get(`page/${id}`);
  }

  getPageByMenuItemId(id: number): Observable<IPage> {
    return this.data.get(`page/menu/${id}`);
  }

  getPageByRoute(route: string): Observable<any> {
    return this.data.get(`page/route${route}`);
  }

  updatePage(payload: IPage): Observable<any> {
    return this.data.put('page', payload);
  }

  save(payload: FormData, message?: string): Observable<any> {
    return this.data.post('page/save', payload, message);
  }
}
